import { render, staticRenderFns } from "./hotel_order.vue?vue&type=template&id=4d033375&scoped=true&"
import script from "./hotel_order.vue?vue&type=script&lang=js&"
export * from "./hotel_order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d033375",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d033375')) {
      api.createRecord('4d033375', component.options)
    } else {
      api.reload('4d033375', component.options)
    }
    module.hot.accept("./hotel_order.vue?vue&type=template&id=4d033375&scoped=true&", function () {
      api.rerender('4d033375', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/components/hotel_order.vue"
export default component.exports